/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/cloud_rain'
export default icon
